import UploadButtons from './UploadButtons';

export default UploadButtons;
